import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchTeamSprints } from '../../../services/sprints';
import { Sprint } from '../types';

export function useSprints(
  teamId: string | null,
): UseQueryResult<Sprint[], Error> {
  return useQuery<Sprint[], Error>({
    queryKey: ['sprints', teamId],
    queryFn: () => fetchTeamSprints(teamId),
    enabled: !!teamId,
  });
}
